import {
  BackgroundColorInterface,
  BackgroundImageInterface,
  BackgroundStylesInterface,
} from 'common/types/background-interfaces'
import {
  backgroundColorCss,
  backgroundCss,
  mobileBackgroundCss,
} from 'common/utils/styleUtilsNew'
import { css, styled } from 'styled-components'

export interface WebsiteFooterBackgroundUiProps
  extends BackgroundColorInterface,
    BackgroundImageInterface {
  background?: BackgroundStylesInterface
  mobileBackground?: string
  backgroundImage?: string | null
  mobileBackgroundImage?: string | null
}

export const WebsiteFooterBackgroundUi = styled.footer<WebsiteFooterBackgroundUiProps>`

  ${backgroundCss}
  ${backgroundColorCss}
  ${p =>
    p.backgroundImage &&
    css`
      background-image: ${p.backgroundImage};
    `};

  ${p => p.theme.phone} {
    
    ${mobileBackgroundCss}
  }

  ${p =>
    p.theme.isEditorMobileMode &&
    css`
      background-image: ${p.mobileBackgroundImage ?? 'none'};
      ${mobileBackgroundCss}
    `}

`
